import script from "./panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./panel.vue?vue&type=script&setup=true&lang=ts"

import "./panel.vue?vue&type=style&index=0&id=ca9cc656&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca9cc656"]])

export default __exports__